import React from 'react';

const Card = ({ children, className = '', hover = true }) => {
    return (
        <div className={`
      bg-white rounded-3xl border border-green-100 overflow-hidden
      ${hover ? 'transition-all duration-500 hover:shadow-2xl hover:-translate-y-2' : ''}
      ${className}
    `}>
            {children}
        </div>
    );
};

export default Card;
